import React from "react";
import { FeatureCardProps } from "../types";
import FeatureCard from "./FeatureCard";

interface FeaturesProps {
  features: FeatureCardProps[];
}

const Features: React.FC<FeaturesProps> = ({ features }) => {
  return (
    <div className="w-full max-w-[1240px] mx-auto px-4">
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-[16px] sm:gap-[6px] justify-items-center sm:justify-items-stretch">
        {features.map((feature) => (
          <FeatureCard
            key={feature.title}
            icon={feature.icon}
            title={feature.title}
            description={feature.description}
          />
        ))}
      </div>
    </div>
  );
};

export default Features;
